<template>

    <div class="criterion-input input-text">
        <input @change="setCriterion"
               type="number"
               min="0.5"
               step="0.1"
               :name="name"
               :placeholder="placeholder"
               :class="{ unvalid : 'unvalid'} "
               v-model.number="value" />
        <span v-if="postfix" v-html="postfix" class="postfix"></span>
        <slot></slot>
    </div>

</template>

<script>
    export default{
        data(){
            return{
                value : ''
            }
        },
        props : ['name', 'selectedValue', 'postfix', 'placeholder', 'unvalid'],
     
        methods : {
            setCriterion(){
                this.$store.commit('setCriterionValue', {name:this.name, value : this.value})
            },
        },
        created(){
            this.$store.commit('setCriterionValue', {name:this.name, value : this.value})
        },

    }
</script>

<style scoped>
    .criterion-input{
        margin-bottom: 15px;
    }

input{
    padding: 15px 8px;
    text-align: center;
    border-radius: 12px;
    border:1px solid #d7d7d7;
    max-width: 145px;
    }
    .postfix{
        margin-left: 15px;
    }
    .step-has-errors .unvalid{
        border:1px solid #f23434;
    }
</style>